import { db } from '../fierbase/config';
import { useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useAuth } from '../store/hooks/setting';
import { collection, addDoc } from "firebase/firestore";
import { PageNavigate } from '../component/navigate/pageNavigate';
const AddFolder = () => {
    const history = useNavigate();
    const currentUser = useAuth();
    const colors = useSelector(state => state.colors.colors);
    const { register, formState: { errors }, handleSubmit } = useForm();
    const handleCategory = async (data) => {
        await addDoc(collection(db, "folder"), {
            foldername: data.foldername,
            colorId: data.color,
            userID: currentUser.uid,
            id: data.foldername,
        });
        history('/category')
        console.log(data.color)
    }
    return (
        <>
            <div className="container">
                <PageNavigate
                    pagetitle="Добавить список"
                />
                <form className='task-form"' onSubmit={handleSubmit(handleCategory)}>
                    <div className="task-form__wrapper">
                        <div className="task-input">
                            <span className="form-group__text">Название списка</span>
                            <input
                                style={errors.foldername && { border: "1px solid red" }}
                                {...register("foldername", { required: true })}
                                placeholder="Начните вводить...."
                            />
                            {errors.foldername?.type === 'required' && <p className="error" role="alert">Введите название списка</p>}
                        </div>
                        <div className="task-color">
                            <span className="form-group__text">Цвет</span>
                            <div className="task-color__items">
                                {colors.map((color) => (
                                    <div className="color-item" key={color.hex}>
                                        <input
                                            type="radio"
                                            id={`${color.hex}`}
                                            value={color.hex}
                                            checked={color ? 'checked' : ''}
                                            {...register("color", { required: true })}
                                        />
                                        <label className='badge' style={{ background: color.hex }} htmlFor={`${color.hex}`}></label>
                                    </div>
                                ))}
                            </div>
                            {/* {errors.color?.type === 'required' && <p className="error" role="alert">Выберите цвет</p>} */}
                        </div>
                        <button className="form-button" disabled={errors.foldername}>
                            Подтвердить
                        </button>
                    </div>
                </form>
            </div>
        </>
    )
}
export { AddFolder }